export const DealTypes = {
  REWARD: "reward",
  REWARDS: "rewards",
  PROMOTION: "promotion",
  PROMOTIONS: "promotions",
};
